import { IconChevronRight, IconQuestion, WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'
import { useAppHeaderIntercomLauncher } from './useAppHeaderIntercomLauncher'
import { AppHeaderButtonStyled } from '../styles/AppHeaderButtonStyled'
import { AppHeaderIntercomLauncherIconStyled } from '../styles/AppHeaderIntercomLauncherIconStyled'

export const AppHeaderIntercomLauncher = () => {
  const intl = useProcurifyIntl()
  const {
    states: { isEnabled, isOpen },
    commands: { toggleMessenger },
  } = useAppHeaderIntercomLauncher()

  if (!isEnabled) {
    return null
  }

  return (
    <WithTooltip title={intl.formatMessage(messages.getHelp)}>
      <AppHeaderButtonStyled
        aria-expanded={isOpen}
        aria-label={intl.formatMessage(messages.getHelp)}
        onClick={toggleMessenger}
      >
        <AppHeaderIntercomLauncherIconStyled $isOpen={isOpen}>
          <IconQuestion size={24} color='textPrimary' />
          <IconChevronRight size={20} color='textPrimary' />
        </AppHeaderIntercomLauncherIconStyled>
      </AppHeaderButtonStyled>
    </WithTooltip>
  )
}

AppHeaderIntercomLauncher.displayName = 'AppHeaderIntercomLauncher'
